import { render } from "./AddNewAdvertising.vue?vue&type=template&id=aa1760d6&scoped=true"
import script from "./AddNewAdvertising.vue?vue&type=script&lang=js"
export * from "./AddNewAdvertising.vue?vue&type=script&lang=js"

import "./AddNewAdvertising.vue?vue&type=style&index=0&id=aa1760d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa1760d6"]])

export default __exports__